import { HttpErrorResponse } from "@angular/common/http";
import { Component, OnInit, ViewChild } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { DatatableComponent } from "@swimlane/ngx-datatable";
import { ApiService } from "app/main/services/Api/api.service";
import { ToastService } from "app/main/services/Toast/toast.service";
import { ContentHeader } from "../ContentHeader";
import { ApiResponse } from "../ApiResponse";
import { CartItemRow } from "./CartItemRow";
import { UserCartItemResponseDto } from "../users/UserCartItemResponseDto";


@Component({
  selector: "app-user-cart-item",
  templateUrl: "./user-cart-item.component.html",
  styleUrls: ["./user-cart-item.component.scss"],
})
export class UserCartItemComponent implements OnInit {
  contentHeader!: ContentHeader;
  columns: any = [];
  rows: CartItemRow[] = [];
  temp: CartItemRow[] = [];
  responseMessage: any;
  @ViewChild(DatatableComponent) public table!: DatatableComponent;

  constructor(
    private modalService: NgbModal,
    private api: ApiService,
    public toastService: ToastService,
  ) {}

  ngOnInit() {
    document.getElementById("الرئيسية")?.classList.remove("active");
    document.getElementById("الفعاليات")?.classList.remove("active");
    document.getElementById("المشرفين")?.classList.remove("active");
    document.getElementById("المستخدمين")?.classList.remove("active");
    document.getElementById("طلبات المشرفين")?.classList.remove("active");
    document.getElementById("العروض")?.classList.remove("active");
    document.getElementById("المسئولين")?.classList.remove("active");

    this.columns = [
      {
        prop: "selected",
        name: "",
        sortable: false,
        canAutoResize: false,
        draggable: false,
        resizable: false,
        headerCheckboxable: true,
        checkboxable: true,
        width: 50,
      },
      { prop: "#" },
      { prop: "TicketName", name: "اسم التذكره" },
      { prop: "TicketPrice", name: "سعر التذكره" },
      { prop: "EventName", name: "اسم الفعاليه" },
      { prop: "PromoCodeUsed", name: "اسم الفعاليه" },
      { prop: "PurchasedTickets", name: "عدد التذاكر المشتراه" },
      { prop: "CancelledTickets", name: "عدد التذاكر الملغاه" },
      { prop: "RefundedTickets", name: "عدد التذاكر المسترده" },
      { prop: "UserName", name: "اسم المستخدم" },
      { prop: "UserPhoneNumber", name: "رقم المستخدم" },
      { prop: "Status", name: "حاله التذكره" },
    ];
    this.api.showUserCartItems(1, 100).subscribe({
      next: (response: ApiResponse<UserCartItemResponseDto[]>) => {
        console.log("API response:", response);

        const list = response?.data ?? [];

        if (!Array.isArray(list)) {
          console.error("Expected array but got:", list);
          this.rows = [];
          this.temp = [];
          return;
        }

        this.rows = list.map((item: UserCartItemResponseDto, index: number) => ({
          id: item.id,
          index: index + 1,
          TicketName: item.ticketName ?? '',
          TicketPrice: item.ticketPrice ?? 0,
          EventName: item.eventName ?? '',
          PromoCodeUsed: item.promoCodeUsed ?? '',
          PurchasedTickets: item.numberOfTickets ?? 0,
          CancelledTickets: item.numberOfCancelledTickets ?? 0,
          RefundedTickets: item.numberOfRefundedTickets ?? 0,
          AvailableTickets: item.numberOfAvailableTickets ?? 0,
          UserName: item.userName ?? '',
          UserPhoneNumber: item.userPhoneNumber ?? '',
          Status: item.status ?? '',
          userId: item.userId,
          ticketId: item.ticketId,
        }));

        this.temp = [...this.rows];
      },
      error: (error: HttpErrorResponse) => {
        console.error("Error fetching user cart items:", error);
      },
    });
    this.contentHeader = {
      headerTitle: "تقارير تذاكر المستخدمين",
      actionButton: false,
    };
  }
  updateFilter(event: any) {
    const val = event?.target?.value ? event.target.value.toLowerCase() : "";

    // Filter data by checking all columns
    const temp = this.temp.filter((row: CartItemRow) => {
      return Object.keys(row).some((key) =>
        (row as any)[key]?.toString().toLowerCase().includes(val)
      );
    });

    // Update the rows
    this.rows = temp;
    // Reset to first page
    if (this.table) {
      this.table.offset = 0;
    }
  }
  public onLimitChange(limit: any): void {
    this.changePageLimit(limit);
    if (this.table) {
      this.table.limit = this.currentPageLimit;
      this.table.recalculate();
      setTimeout(() => {
        if (this.table && this.table.bodyComponent && this.table.bodyComponent.temp && this.table.bodyComponent.temp.length <= 0) {
          this.table.offset = Math.floor(
            (this.table.rowCount - 1) / this.table.limit
          );
        }
      });
    }
  }
  private changePageLimit(limit: any): void {
    this.currentPageLimit = parseInt(limit, 10);
  }
  public onVisibleChange(visible: any): void {
    this.currentVisible = parseInt(visible, 10);
  }
  public currentVisible: number = 3;
  public currentPageLimit: number = 10;
  public readonly pageLimitOptions = [
    { value: 5 },
    { value: 10 },
    { value: 25 },
    { value: 50 },
    { value: 100 },
  ];
  public chkBoxSelected: CartItemRow[] = [];
  customChkboxOnSelect({ selected }: { selected: CartItemRow[] }) {
    this.chkBoxSelected.splice(0, this.chkBoxSelected.length);
    this.chkBoxSelected.push(...selected);
  }
  selectedRow: any = null;
  selectedQuantity: number = 1;

  modalOpenDefault(content: any, row: any) {
    this.selectedRow = row;
    this.selectedQuantity = 0; // default value when modal opens

    this.modalService.open(content, {
      centered: true,
      size: "md",
    });
  }
  confirmChangeStatus(selectedRow: CartItemRow, selectedQuantity: number, CartItemPaymentStatus: number) {
    let body = {
      id: selectedRow.id,
      userId: selectedRow.userId,
      ticketId: selectedRow.ticketId,
      numberOfTickets: selectedRow.PurchasedTickets - selectedQuantity,
    };
    this.api.changeUserCartItemState(body).subscribe({
      next: (response: any) => {
        this.responseMessage = response.message;
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      },
      error: (error: HttpErrorResponse) => {
        this.responseMessage = error.error.message + "❌";
        setTimeout(() => {
          this.responseMessage = '';
        }, 4000);
      },
    });
  }
}
